import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import MaterialTable from 'material-table';
import UpdateAddress from './create';
import { Trim } from '../../common/util';
import { getPaginatedAddresses, deleteAddress } from '../../actions/admin/addressAction';
import { updateModalContent, toggleModal } from '../../actions/modal';

const AddressTable = (props) => {
  const table = useRef(null);
  const formCreateRef = useRef();
  const [pageSize, setPageSize] = useState(20);

  const columns = [
    { title: 'Name', field: 'name', defaultSort: 'asc' },
    { title: 'Address', field: 'address', sorting: false },
    { title: 'Postal Code', field: 'postalCode', sorting: false },
    { title: 'Lat', field: 'lat', sorting: false },
    { title: 'Lng', field: 'lng', sorting: false },
    { title: 'Type', field: 'type', sorting: false },
  ];

useEffect(() => {
  if (table.current) {
    table.current.onQueryChange();
  }
}, [props.updateListOnCreate, props.resetValue]);

const updateDataTable = () => {
  if (table.current) {
    table.current.onQueryChange();
  }
  props.reloadPostalCodeTable();
};

const onDeleteAddress = (id) => {
  props.updateModalContent({
    title:        'Are you sure?',
    content:      'This address will be deleted.',
    actionButton: {
      actionText: 'Yes, Delete!',
      actionType: 'danger',
      action:     () => {
        try {
          props.deleteAddress(id).then((response) => {
            if (response.status === 200) {
              toast.success('Address Deleted.');

              updateDataTable();
            } else {
              toast.error('An unexpected error has occurred');
            }
          })
            .catch((err) => {
            toast.error(err);
            });
        } catch (err) {
          toast.error(err);
        }
      },
    },
    cancelText:       'No',
    closeAfterAction: true,
  });

  props.toggleModal();
};

const onUpdateAddress = (data) => {
  data.name = data.name ? Trim(data.name) : null;

  props.updateModalContent({
    title:        'Update Address',
    content:      <UpdateAddress addressData={data} updateList={updateDataTable} ref={formCreateRef} />,
    actionButton: {
      actionText: 'Save',
      actionType: 'primary',
      action:     () => formCreateRef.current.submitForm(),
    },
    cancelText:       'Cancel',
    closeAfterAction: false,
  });

  props.toggleModal();
};

return (
  <div>
    {/** The pagination in MaterialTable is not a true pagination; if we provide
       * the entire data set it has a ability to show by pages and pageSize.
       * If we have huge data set we will need an api to return the paginated
       * data set. Refer to /src/components/admin/category/List.js for how that is
       * achieved in functional component.
        */}
    <MaterialTable
      tableRef={table}
      className="material-table"
      title=""
      columns={columns}
      onChangeRowsPerPage={() => {
        setPageSize(pageSize);
      }}
      data={async (query) => {
        try {
          if (props.updateListOnCreate === false) {
            query.name = '';
            query.address = '';
            query.postalCode = '';
            query.lat = '';
            query.lng = '';
            query.type = '';

            for (const filter of query.filters) {
              if (filter.column.field === 'name') { query.name = filter.value; }
              if (filter.column.field === 'address') { query.address = filter.value; }
              if (filter.column.field === 'postalCode') { query.postalCode = filter.value; }
              if (filter.column.field === 'lat') { query.lat = filter.value; }
              if (filter.column.field === 'lng') { query.lng = filter.value; }
              if (filter.column.field === 'type') { query.type = filter.value; }
            }
          } else {
            // if updateListOnCreate eq. true, this funtion resetValue will reset back to FALSE
            props.resetValue();
          }

          query.orderDir = query.orderDirection;
          const result = await props.getPaginatedAddresses(query);
          let { rows, totalCount } = result;
          let { page }             = query;

          if (rows.length === 0) {
            page = 0;

            if (totalCount !== 0) {
              const resultFirstPage = await props.getPaginatedAddresses({ ...query, page });
              rows = resultFirstPage.rows;
            }
          }

          return ({
            data: rows,
            page,
            totalCount,
          });
        } catch (err) {
          toast.error(err);

          // clear table params, if theres an error.
          return ({
            data:       [],
            page:       0,
            totalCount: 0,
          });
        }
      }}
      actions={[
        {
          icon:    'edit',
          tooltip: 'Update Address',
          onClick: (event, address) => onUpdateAddress(address),
        },
        {
          icon:    'delete',
          tooltip: 'Delete Address',
          onClick: (event, address) => onDeleteAddress(address.id),
        },
      ]}
      options={{
        pageSize,
        actionsColumnIndex:  -1,
        emptyRowsWhenPaging: false,
        filtering:           true,
        search:              false,
        sorting:             true,
      }}
    />
  </div>
);
};

AddressTable.propTypes = {
  reloadPostalCodeTable: PropTypes.func,
  updateListOnCreate:    PropTypes.bool.isRequired,
  resetValue:            PropTypes.func.isRequired,
  getPaginatedAddresses: PropTypes.func.isRequired,
  deleteAddress:         PropTypes.func.isRequired,
  updateModalContent:    PropTypes.func.isRequired,
  toggleModal:           PropTypes.func.isRequired,
};

AddressTable.defaultProps = {
  reloadPostalCodeTable: () => {},
};

// map props to redux state (use Chrome Redux DevTools to help identify how state are stored)
/*function mapStateToProps(state) {
  return { };
}*/

// map the redux action creators to props
const mapActionToProps = {
  toggleModal, updateModalContent,
  getPaginatedAddresses, deleteAddress,
};

// connect(mapStateToProps, actions to component as props)(component)
export default connect(
null,
mapActionToProps,
)(AddressTable);
